import SuccessResponse from '../responses/SuccessResponse';
import PaymentDeclinedResponse from '../responses/PaymentDeclinedResponse';
import TimeoutResponse from '../responses/TimeoutResponse';
import Response from '../base/Response';

export default class TransactionResult {
	/**
	 * Transaction response type
	 */
	transaction_type?: string = undefined;

	/**
	 * Transaction redeemed points
	 */
	transaction_redeemed_points?: number = undefined;

	/**
	 * Approved amount on capture/sale
	 */
	transaction_approved_amount?: number = undefined;

	/**
	 * Initial or registered transaction amount
	 */
	transaction_amount?: number = undefined;

	/**
	 * Transaction AUTH reference code
	 */
	transaction_auth?: string = undefined;

	/**
	 * Transacction network terminal ID
	 */
	transaction_terminal?: string = undefined;

	/**
	 * Transaction network merchant ID
	 */
	transaction_merchant?: string = undefined;

	/**
	 * CVV2 result response code
	 */
	response_cvn?: string = undefined;

	/**
	 * Address verification code response
	 */
	response_avs?: string = undefined;

	/**
	 * CAVV network evaluation result code
	 */
	response_cavv?: string = undefined;

	/**
	 * Transaction identifier
	 */
	transaction_id?: string = undefined;

	/**
	 * Transaction STAN, processor transacction identifier or transaction reference
	 */
	transaction_reference?: string = undefined;

	/**
	 * Transaction result time
	 */
	transaction_time?: string = undefined;

	/**
	 * Transaction result date
	 */
	transaction_date?: string = undefined;

	/**
	 * Response is financial approved
	 */
	response_approved?: boolean = undefined;

	/**
	 * Response fatal not completed or excecution interrupted
	 */
	response_incomplete?: boolean = undefined;

	/**
	 * Proccesor response code
	 */
	response_code?: string = undefined;

	/**
	 * Network response time
	 */
	response_time?: string = undefined;

	/**
	 * Proccesor response message
	 */
	response_reason?: string = undefined;

	/**
	 * Transaction installment type
	 */
	installment_type?: string = undefined;

	/**
	 * Transaction installment value
	 */
	installment_months?: string = undefined;

	/**
	 * Payment unique identifier
	 */
	payment_uuid?: string = undefined;

	/**
	 * Payment integrity validation hash
	 */
	payment_hash?: string = undefined;

	/**
	 * Validate if response type is valid for parse
	 *
	 * @param response
	 * @return
	 */
	static validateResponse(response: Response): boolean {
		return response instanceof SuccessResponse
			|| response instanceof PaymentDeclinedResponse
			|| response instanceof TimeoutResponse;
	}

	/**
	 * Convert success response to transaction entity
	 *
	 * @param response
	 * @return
	 */
	static fromResponse(response: Response): TransactionResult {
		const entity = new TransactionResult();

		Object.getOwnPropertyNames(response.data).map(prop => {
			if (prop in entity) {
				const key = prop as keyof TransactionResult;

				entity[key] = response.data[prop];
			}
		})

		return entity;
	}
}
